import { render, staticRenderFns } from "./CabTextarea.vue?vue&type=template&id=4e7c3c21&scoped=true&"
import script from "./CabTextarea.vue?vue&type=script&lang=js&"
export * from "./CabTextarea.vue?vue&type=script&lang=js&"
import style0 from "./CabTextarea.vue?vue&type=style&index=0&id=4e7c3c21&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7c3c21",
  null
  
)

export default component.exports